export const APP_NAME = "CicloGest";
export const APP_TAGLINE = "Il gestionale per negozi di bici";
export const DEMO_VIDEO_URL = "";
export const TESTIMONIANZA_FOTO = "/img/vlr-bike-negozio.jpg";
export const CONTATTO_WHATSAPP = "393494444787";
export const MESSAGGIO_CONTATTO = "Ciao, ho visto CicloGest e vorrei qualche informazione prima di provarlo.";
export const RECENSIONI = [];
export const PREZZO_MESE = 39;
export const PREZZO_ANNO = 399;
export const GIORNI_PROVA = 14;
